var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWestend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#676E7E",
    d: "M0 0h56v56H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M18.848 40 11 16h6.027l4.497 14.357L25.93 16h4.407l4.515 14.357L39.26 16h6.027l-7.83 24h-4.77l-4.552-14.373L23.545 40h-4.697Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWestend);
export default __webpack_public_path__ + "static/media/westend.d2256c4fb719c6738bbe03f24408a797.svg";
export { ForwardRef as ReactComponent };